import { Injectable } from '@angular/core';

export interface MaterialSymbolIcon {
	name: string;
	tags: string[];
}

@Injectable({ providedIn: 'root' })
export class MaterialSymbolsIconsService {
	private _icons: Promise<MaterialSymbolIcon[]> | undefined;

	get icons() {
		if (this._icons == null) {
			this._icons = fetchIcons();
		}
		return this._icons;
	}
}

async function fetchIcons(): Promise<MaterialSymbolIcon[]> {
	const response = await fetch('/assets/material-symbols-icons.json');
	if (!response.ok) {
		throw new Error(`Failed to load material symbols icons (${response.status})`);
	}
	return (await response.json()) as MaterialSymbolIcon[];
}
